import { Router } from '@angular/router';
import { Inject, Injectable } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';
import { APP_HOME_ROUTE, NOT_FOUND_PAGE } from '~shared/constants';
import { Observable, of } from 'rxjs';

@Injectable()
export class HomepageNavigatorService {
  constructor(
    private readonly featureFlagService: ActiveFeaturesConfigcatService,
    private readonly router: Router,
    @Inject(APP_BASE_HREF) private baseHref: string,
  ) {
  }

  navigateToHomepage(): Observable<boolean> {
    window.location.href = `/${this.baseHref.replace(new RegExp('\/', 'g'), '')}/${APP_HOME_ROUTE}`;
    return of(true);
  }

  navigateToNotFoundPage(): Promise<boolean> {
    return this.router.navigate([NOT_FOUND_PAGE])
  }
}
